.panel {
  display: flex;
  flex-direction: column;
  /* Ширину и правую границу задаёт колонка сетки в App.module.css: так панель
     растягивается на всю ширину, когда раскладка схлопывается в одну колонку. */
  width: 100%;
  min-width: 0;
  height: 100%;
  background: var(--surface);
}

.header {
  position: sticky;
  top: 0;
  z-index: 5;
  flex: 0 0 auto;
  padding: var(--sp-5);
  background: var(--surface);
  -webkit-backdrop-filter: var(--glass-blur);
  backdrop-filter: var(--glass-blur);
  border-bottom: 1px solid var(--border);
}

.headRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: var(--sp-4);
}

.headTitle {
  font-size: var(--fs-lg);
  font-weight: 600;
}

.headCount {
  color: var(--text-3);
  font-size: var(--fs-sm);
}

/* Перенос — на случай узкой панели: её ширину тянут до 200px (PANEL_MIN_W), и
   вдвоём кнопки туда не встают. Тогда «+ Блок» забирает первую строку целиком,
   а проверка цен уезжает под неё — это лучше, чем обрезанная о край подпись. */
.actionsRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3);
  margin-bottom: var(--sp-4);
}

/* Проверка цен стоит рядом с «+ Блок», но ширину с ней не делит (резинка
   button.actionBtn выше — только у главной кнопки панели): подпись с числом
   рейсов должна читаться целиком и не переноситься по словам. */
.priceBtn {
  white-space: nowrap;
}

/* Счётчик новых блоков + «отметить просмотренными» — показывается только пока
   есть что подсвечивать, поэтому в норме этого ряда просто нет. */
.newRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-3);
  margin-bottom: var(--sp-4);
  padding: var(--sp-2) var(--sp-3);
  background: var(--flight-bg);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
}

.newCount {
  color: var(--flight);
  font-size: var(--fs-sm);
  font-weight: 600;
}

/* Две главные кнопки панели — крупнее рядовых: с них начинается работа
   с библиотекой, и жать по ним приходится чаще всего.
   Селектор с именем элемента обязателен: одноклассовый проигрывает глобальному
   .btn с его отступами. Прежний `.actionsRow .btn` не работал вовсе — в CSS
   Modules `.btn` локализуется и до глобального класса не достаёт. */
button.actionBtn {
  flex: 1 1 0;
  justify-content: center;
  padding: var(--sp-4) var(--sp-5);
}

.search {
  width: 100%;
}

.scroll {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: var(--sp-5);
}

.group {
  margin-bottom: var(--sp-5);
}

.groupHead {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  width: 100%;
  padding: var(--sp-2) 0;
  background: transparent;
  border: none;
  color: var(--text-2);
  font-size: var(--fs-sm);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  cursor: pointer;
}

.groupHead:hover {
  color: var(--text);
}

.chevron {
  flex: 0 0 auto;
  transition: transform 120ms ease;
}

.chevron.collapsed {
  transform: rotate(-90deg);
}

@media (prefers-reduced-motion: reduce) {
  .chevron {
    transition: none;
  }
}

.groupCount {
  color: var(--text-3);
  font-weight: 400;
  text-transform: none;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  margin: var(--sp-3) 0 0;
  padding: 0;
  list-style: none;
}

.empty {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
  padding: var(--sp-6) var(--sp-3);
  text-align: center;
}

.emptyTitle {
  font-size: var(--fs-md);
  font-weight: 600;
  color: var(--text);
}

.emptyText {
  color: var(--text-3);
  font-size: var(--fs-sm);
  line-height: 1.5;
}

.emptyActions {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
}

.noResults {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--sp-4);
  padding: var(--sp-7) var(--sp-3);
  text-align: center;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

/* ── Мобильный вид (порог продублирован в ui/shell/useIsMobile.ts) ────────
   Библиотека перестаёт быть колонкой и становится лентой поверху экрана:
   группы идут слева направо, внутри каждой — её карточки в ряд. Прокрутка
   одна и горизонтальная, вложенных скроллов в ленте нет. */
@media (max-width: 720px) {
  .panel {
    height: auto;
  }

  /* Липнуть не к чему: панель больше не прокручивается по вертикали сама. */
  .header {
    position: static;
    padding: var(--sp-4) var(--sp-4) var(--sp-3);
  }

  /* Панель свёрнута в аккордеон (D11) — под кнопкой шапки ничего нет, нижняя
     граница осталась бы висеть в пустоте у самого края карточки. */
  .headerCollapsed {
    padding-bottom: var(--sp-4);
    border-bottom: none;
  }

  .headRow,
  .actionsRow {
    margin-bottom: var(--sp-3);
  }

  /* Шапка-кнопка аккордеона (D11): «Библиотека · N блоков» + шеврон. Занимает
     место обычного .headRow, но кликабельна и держит тач-зону в 44px —
     на телефоне это единственный способ свернуть/развернуть панель, кнопки
     на швах (App.tsx) там не рисуются. */
  .accordionHead {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--sp-3);
    width: 100%;
    min-height: 44px;
    margin-bottom: var(--sp-3);
    padding: 0;
    background: transparent;
    border: none;
    color: var(--text);
    font: inherit;
    text-align: left;
    cursor: pointer;
  }

  .accordionTitle {
    font-size: var(--fs-lg);
    font-weight: 600;
  }

  .accordionHead .chevron {
    flex: 0 0 auto;
  }

  .scroll {
    flex: none;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    gap: var(--sp-6);
    padding: var(--sp-4);
    overflow-x: auto;
    overflow-y: hidden;
    overscroll-behavior-x: contain;
    scroll-snap-type: x proximity;
  }

  /* Группа — вертикальный блок ленты: подпись сверху, карточки под ней в ряд. */
  .group {
    display: flex;
    flex-direction: column;
    flex: none;
    margin-bottom: 0;
  }

  /* Подпись группы липнет к левому краю ленты: пока едешь по карточкам одного
     типа, видно, какого они типа. Без этого заголовок уезжает через два-три
     свайпа, и лента превращается в однородный ряд карточек без разделов.

     Отступ слева тот же, что у самой ленты, — на первой группе пришпиленное
     положение совпадает с обычным, и подпись не прыгает при первом же свайпе.
     Ширина по содержимому (align-self), иначе липла бы коробка во всю группу,
     а текст внутри неё всё равно уезжал бы за край. */
  .groupHead {
    position: sticky;
    left: var(--sp-4);
    z-index: 1;
    align-self: flex-start;
    width: auto;
    white-space: nowrap;
    /* Подложка нужна на стыке групп: подпись следующей выезжает навстречу
       уходящей, и без фона они на миг накладываются буквами. */
    background: var(--surface);
    padding-right: var(--sp-3);
    -webkit-backdrop-filter: var(--glass-blur);
    backdrop-filter: var(--glass-blur);
    border-radius: var(--radius);
  }

  .list {
    flex: 1 1 auto;
    flex-direction: row;
    align-items: stretch;
  }

  /* Одинаковая ширина карточек — иначе лента едет рывками разной длины.
     Высота общая: карточки тянутся по самой высокой в ряду. */
  .list > li {
    display: flex;
    flex: none;
    width: 232px;
    scroll-snap-align: start;
  }

  .list > li > * {
    width: 100%;
  }

  /* Пустая библиотека и «ничего не нашлось» — не лента, а сообщение во всю
     ширину экрана: горизонтально им ехать некуда. */
  .empty,
  .noResults {
    flex: 1 1 auto;
    padding: var(--sp-5) var(--sp-3);
  }

  .emptyActions {
    flex-direction: row;
    justify-content: center;
  }
}
